<template>
	<div style="background-color: #2f2f2f; font-weight: 400">

		<b-container style="max-width: 800px;" class="pt-5 pb-3 mx-auto">

			<div class="d-none d-md-block">

				<div class="d-flex justify-content-center align-items-center">

					<img class="sponsor-adidas mainSponsor" src="/img/layout/adidas.png" />
					<img class="sponsor-auberge mainSponsor" src="/img/layout/auberge.png" />
					<img class="sponsor-riyhad mainSponsor mx-5" src="/img/layout/riyhad.png" />
					<img class="sponsor-toyota mainSponsor" src="/img/layout/toyota.png" />

				</div>

				<div style="margin-top: 70px; margin-bottom: 40px" class="d-flex justify-content-center align-items-center">

					<img class="sponsor-enel" src="/img/layout/enel.png" />
					<img class="sponsor-ibl" src="/img/layout/ibl-banca.png" />
					<img class="sponsor-konami" src="/img/layout/konami.png" />
					<img class="sponsor-starcasino" src="/img/layout/starcasino.png" />
					
				</div>

			</div>
			<div class="d-block d-md-none text-center">


					<div><img class="sponsor-adidas-mob mainSponsor" src="/img/layout/adidas.png" /></div>
					<div><img class="sponsor-auberge-mob mainSponsor" src="/img/layout/auberge.png" /></div>
					<div><img class="sponsor-riyhad-mob mainSponsor mx-5" src="/img/layout/riyhad.png" /></div>
					<div><img class="sponsor-toyota-mob mainSponsor" src="/img/layout/toyota.png" /></div>

					<div style="height: 40px"></div>

					<div><img class="sponsor-enel-mob" src="/img/layout/enel.png" /></div>
					<div><img class="sponsor-ibl-mob" src="/img/layout/ibl-banca.png" /></div>
					<div><img class="sponsor-konami-mob" src="/img/layout/konami.png" /></div>
					<div><img class="sponsor-starcasino-mob" src="/img/layout/starcasino.png" /></div>
					

			</div>

			<hr class="niceSeparator" />

			<center>
				<ul class="footMenu">
					<li class="mx-3"><a target="_blank" @click.prevent="modal.termini = true" href="https://www.asroma.com/it/terminiecondizioni">{{ $t('gen.terminiecondizioni') }}</a></li>
					<li class="mx-3"><a target="_blank" @click.prevent="modal.privacy = true" href="https://www.asroma.com/it/informativaprivacy">{{ $t('gen.infoprivacy') }}</a></li>
					<li class="mx-3"><a target="_blank" @click.prevent="$root.modal.cookie = true" href="https://www.asroma.com/it/cookie-policy">{{ $t('gen.cookie') }}</a></li>
				</ul>
			</center>

			<ModalTermini @close="modal.termini = false" v-if="modal.termini == true"></ModalTermini>
			<ModalPrivacy @close="modal.privacy = false" v-if="modal.privacy == true"></ModalPrivacy>
			<ModalCookie @close="$root.modal.cookie = false" v-if="$root.modal.cookie == true"></ModalCookie>
			<ModalLinkTwo @close="$root.modal.link_two = false" v-if="$root.modal.link_two == true"></ModalLinkTwo>
			<ModalLinkFour @close="$root.modal.link_four = false" v-if="$root.modal.link_four == true"></ModalLinkFour>

			<p class="copyText m-0 text-center">
				© 2018 SOCCER S.A.S. DI BRAND MANAGEMENT S.R.L. – P.IVA VAT 09305501000 - ALL RIGHTS RESERVED. THE AS ROMA NAMES, LOGOS AND ARTWORK ARE REGISTERED OR UNREGISTERED TRADEMARKS OF SOCCER S.A.S. DI BRAND MANAGEMENT S.R.L. ALL OTHER TRADEMARKS MAY BE THE PROPERTY OF THEIR RESPECTIVE HOLDERS.
			</p>

		</b-container>

	</div>
</template>

<script>

import ModalTermini from '@/components/Partials/ModalTermini.vue'
import ModalPrivacy from '@/components/Partials/ModalPrivacy.vue'
import ModalCookie from '@/components/Partials/ModalCookie.vue'

import ModalLinkTwo from '@/components/Partials/ModalLinkTwo.vue'
import ModalLinkFour from '@/components/Partials/ModalLinkFour.vue'
import $ from 'jquery';

export default {
	name: 'WebFooter',
	props: {},
	data: function() {
		return {
			modal: {
				termini: false,
				privacy: false,
				cookie: false
			}
		}
	},
	created: function() {
		var s = this;
		$(document).on('click', 'a.open-modal', function(i) {
			console.log(s.$root);
			var m = $(this).attr('m');
			s.$root.modal[m] = true;
			//alert(m);
		});
	},
	components: {
		ModalTermini,
		ModalPrivacy,
		ModalCookie,
		ModalLinkTwo,
		ModalLinkFour
	}
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
	
	.copyText {
		color: #757575;
		font-size: 0.74rem;
		line-height: 1.7;
	}

	.niceSeparator {
		border-color: hsla(0,0%,100%,.5);
		margin-top: 2em;
		margin-bottom: 2em;
	}

	.footMenu {
		list-style: none;
	}

	.footMenu li {
		font-size: 0.85em;
		color: #757575;
		display: inline-block;
	}

	.footMenu li a {
		color: #fff;
	}

	.footMenu li a:hover {
		text-decoration: none;
	}

	.mainSponsor {
		filter: brightness(0) invert(1);
	}

	.secondarySponsor {
		max-width: 50%;
		max-height: 2rem;

		@media (min-width: 502px){
			max-width: 25% !important;
		}


		@media (min-width: 802px){
			max-width: 35% !important;
		}

	}

	.sponsor-adidas {
		width: 10%;
	}

	.sponsor-auberge {
		width: 25%;
		margin-left: 50px;
		margin-right: 35px;
	}

	.sponsor-riyhad {
		width: 15%;
	}

	.sponsor-toyota {
		width: 18%;
	}

	.sponsor-adidas-mob {
		width: 15%;
		margin-bottom: 35px;
	}

	.sponsor-auberge-mob {
		width: 25%;
		margin-bottom: 35px;
	}

	.sponsor-riyhad-mob {
		width: 20%;
		margin-bottom: 35px;
	}

	.sponsor-toyota-mob {
		width: 23%;
	}

	.toyota {
		width: 140px;
		height: 27px;
	}


	.sponsor-enel {
		filter: brightness(0) invert(1);
		width: 18%;
	}

	.sponsor-konami {
		filter: brightness(0) invert(1);
		width: 18%;
		margin-left: 40px;
		margin-right: 40px;
	}

	.sponsor-starcasino {
		filter: brightness(0) invert(1);
		width: 18%;
	}


	.sponsor-ibl {
		margin-left: 40px;
		filter: brightness(0) invert(1);
		width: 30%;
	}
	.sponsor-ibl-mob {
		filter: brightness(0) invert(1);
		width: 25%;
		margin-bottom: 20px;
	}

	.sponsor-enel-mob {
		filter: brightness(0) invert(1);
		width: 18%;
		margin-bottom: 20px;
	}

	.sponsor-konami-mob {
		filter: brightness(0) invert(1);
		margin-bottom: 20px;
		width: 22%;
	}

	.sponsor-starcasino-mob {
		filter: brightness(0) invert(1);
		width: 22%;
	}




	.arc {
		width: 121px;
		height: 60px;
	}

	.nb {
		width: 85px;
		height: 60px;
	}

	.db {
		width: 140px;
		height: 56px;
	}

	.fxoro {
		width: 80px;
		height: 42px;
	}

	.konami {
		width: 80px;
		height: 25px;
	}

	.starcasino {
		width: 80px;
		height: 25px;
	}

</style>